// DEFAULT environment (`ng serve` / development). Replaced by environment.prod.ts in production builds.
// Fill every __PLACEHOLDER__ before building (see ../README.md, "Fill the placeholders"),
// or run ../deploy/fill-env.sh with a filled-in .env file.
// Google Maps / Mapbox keys and the Stripe publishable key are NOT set here: the panel reads them
// from the server (Admin > Settings > Map Setting / payment settings).
export const environment = {
  API_URL: "__API_BASE_URL__", // e.g. https://api.example.com  (no trailing slash)
  IMAGE_URL: "__IMAGE_BASE_URL__", // where uploaded images are served, e.g. https://api.example.com or the S3 bucket URL
  SOCKET_URL: "__SOCKET_URL__", // e.g. https://socket.example.com
  HISTORY_URL: "__HISTORY_URL__", // e.g. https://history.example.com

  defaultLang: "en",
  production: false,
  firebaseConfig: {
    apiKey: "__FIREBASE_API_KEY__",
    authDomain: "__FIREBASE_AUTH_DOMAIN__",
    databaseURL: "__FIREBASE_DATABASE_URL__",
    projectId: "__FIREBASE_PROJECT_ID__",
    storageBucket: "__FIREBASE_STORAGE_BUCKET__",
    messagingSenderId: "__FIREBASE_MESSAGING_SENDER_ID__",
    appId: "__FIREBASE_APP_ID__",
    measurementId: "__FIREBASE_MEASUREMENT_ID__"
  },

  additionalFeatured: [
    "FallbackTypesSelection", // Fallback Types Selection
    "AwardDriver", // Award Driver
    "ShowAdditionalDocumentFilter", // Show Additional Document Filter
    "DriverHourlyPlatformFee"
  ]
};
